<template>
  <div class="slider-wrapper">

    <!-- Left slide bar -->
    <transition name="show-by-index">
      <div v-show="(selectedSlide > 0)" class="direction-btn left">
        <div class="icon-holder" v-touch:tap="slideTo('right')">
          <div class="icon white-arrow"></div>
        </div>
      </div>
    </transition>

    <!-- Slider -->
    <div class="bg-slider-wrapper">
      <flickity
        ref="flickity"
        :options="flickityOptions"
      >
        <div v-for="(slide, i) in slides" :key="i"
             :class="[
               'carousel-cell',
               'pure-g',
               (slide.color),
               (slide.color_hover),
               extraHeightClass
               ]"
        >
          <div class="part-left pure-u-1-1 pure-u-md-1-2">
            <div :class="['icon', (slide.icon)]"></div>
          </div>
          <div class="part-right pure-u-1-1 pure-u-md-1-2" v-html="$lang[slide.txt]"></div>
        </div>
      </flickity>
    </div>

    <!-- Right slide bar -->
    <transition name="show-by-index">
      <div v-show="(selectedSlide < (slides.length - 1))" class="direction-btn right">
        <div class="icon-holder" v-touch:tap="slideTo('left')">
          <div class="icon white-arrow"></div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'big-slider',
  data () {
    return {
      flickityOptions: {
        initialIndex: 0,
        accessibility: true,
        prevNextButtons: false,
        pageDots: true,
        dragThreshold: 40,
        contain: true,
        adaptiveHeight: true
      },
      selectedSlide: 0
    }
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    showDots: {
      type: Boolean,
      default: true
    },
    extraHeightClass: {
      type: String,
      default: ''
    }
  },
  beforeMount () {
    this.flickityOptions.pageDots = this.showDots
  },
  mounted () {
    let self = this
    this.$refs.flickity.on('dragEnd', function () {
      self.selectedSlide = self.$refs.flickity.selectedIndex()
    })
  },
  methods: {
    slideTo (side) {
      let self = this
      return () => {
        self.onSlideTo(side)
      }
    },
    onSlideTo (side) {
      if (side === 'right') {
        this.$refs.flickity.previous()
        this.selectedSlide = this.$refs.flickity.selectedIndex()
      } else if (side === 'left') {
        this.$refs.flickity.next()
        this.selectedSlide = this.$refs.flickity.selectedIndex()
      }
    },
    popModal (modal) {
      let self = this
      return () => {
        self.onPopModal(modal)
      }
    },
    onPopModal (modal) {
      // TODO: Pop modal
      console.log('Will soon pop...')
    }
  },
  components: {
    'flickity': Flickity
  }
}
</script>



// WEBPACK FOOTER //
// src/components/big-slider/index.vue